






























































import { Component, Vue, Prop } from 'vue-property-decorator';
import AccordionItem from '@/components/Global/Accordion/AccordionItem.vue';
import { Policy } from '@/common/Policy';
import Card from '@/components/Global/Card.vue';

@Component({
	components: {
		AccordionItem,
		Card
	},
})
export default class Risks extends Vue {
	@Prop() private policyData: Policy;

	get sortRisks() {
		if ( !this?.policyData?.risks ) {
			return [];
		}

		return Object.values(this.policyData.risks).sort( r => r.main_risk === 'Y' ? -1 : 1);
	}
}
